export const CONSULTAR_SAT = "CONSULTAR_SAT";
export const RESPUESTA_CONSULTA_SAT = "RESPUESTA_CONSULTA_SAT";
export const ERROR_CONSULTA_SAT = "ERROR_CONSULTA_SAT";
export const DESCARGAR_CONSULTA_SAT_XLS = "DESCARGAR_CONSULTA_SAT_XLS";
export const REPORTE_XLS_CREADO = "REPORTE_XLS_CREADO";
export const LIMPIAR_MENSAJES = "LIMPIAR_MENSAJES";

export const consultarSAT = (json: string) => ({ type: CONSULTAR_SAT, json });
export const respuestaConsultaSAT = (datos: JSON) => ({type: RESPUESTA_CONSULTA_SAT, datos });
export const errorConsultaSAT = () => ({ type: ERROR_CONSULTA_SAT });
export const descargarConsultaSATXLS = (datos: string) => ({ type: DESCARGAR_CONSULTA_SAT_XLS, datos });
export const reporteXLSCreado = () => ({ type: REPORTE_XLS_CREADO });
export const limpiarMensajes = () => ({type: LIMPIAR_MENSAJES});




// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/inicio_fin_relacion_laboral/modulos/iniciFinRelacionLaboralActions.ts